var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMoreHorizontal({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 4,
    viewBox: "0 0 18 4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 2,
    r: 2,
    transform: "rotate(90 16 2)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 2,
    r: 2,
    transform: "rotate(90 9 2)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2,
    transform: "rotate(90 2 2)"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoreHorizontal);
export default __webpack_public_path__ + "static/media/more-horizontal.0ce4353b.svg";
export { ForwardRef as ReactComponent };